import React, { useEffect } from "react";

const { kakao } = window;

function Loca() {
  useEffect(() => {
    const container = document.getElementById('map');
    const options = {
      center: new kakao.maps.LatLng(37.48453959378652, 127.12233207390916),
      level: 3,
    };
    const map = new kakao.maps.Map(container, options);

    var marker = new kakao.maps.Marker({
      position: map.getCenter(),
      text: '바른 법무사'
    });
    marker.setMap(map);

    var iwContent = '<div style="padding:10px;">바른 법무사 사무소</div>',
      iwPosition = new kakao.maps.LatLng(37.48453959378652, 127.12233207390916);
    var infowindow = new kakao.maps.InfoWindow({
      position: iwPosition,
      content: iwContent
    });
    infowindow.open(map, marker);

  }, [])

  return (
    <div className="inner">
      <h2><b>오시는 길</b></h2>
      <section>
        <div id="map" className="wrap-map">
          {/* kakao map */}
        </div>
        <div className="wrap-txt">
          <ul className="list-loca">
            <li className="ico-address">서울 송파구 법원로8길 13 3층 315호(문정동, 문정헤리움써밋타워)</li>
            <li className="ico-phone">전화 : 02-448-2207</li>
            <li className="ico-fax">팩스 : 02-449-2207</li>
            <li className="ico-email">이메일 : lawbareun@naver.com</li>
          </ul>
        </div>
      </section>
    </div>
  );
}

export default Loca;
